import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute: InvariantJiraRoute = {
	name: 'rapidboard-backlog',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
	query: ['config=insightsConfig'],
};
